module.exports = __webpack_public_path__ + "static/media/H2_Large_TheChamps.d2e1401b.svg";